module.exports = __webpack_public_path__ + "img/thumb_32.d0cd0e5d.jpg";